import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=22819523&scoped=true"
import script from "./CallLogs.vue?vue&type=script&lang=js"
export * from "./CallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22819523",
  null
  
)

export default component.exports